import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Auth } from 'aws-amplify';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-login',
  templateUrl: './app.login.component.html',
  providers: [FormBuilder, MessageService]
})
export class AppLoginComponent {

  loginForm: FormGroup;
  logIn: boolean = true;
  code: string;
  signingIn: boolean;
  needsPassword: boolean;
  confirmingSignUp: boolean;
  showCodeDialog: boolean;
  showResetPasswordDialog: boolean;
  newPassword: string;
  newPasswordAgain: string;
  resettingPassword: boolean;
  newPasswordRequired: boolean;
  user: any;
  totpCode: string;
  showTotpDialog: boolean;
  confirmingTotp: boolean;
  returnUrl: string;
  path: string;
  
  constructor(private formBuilder: FormBuilder, private messageService: MessageService, private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.returnUrl = params['returnUrl'];
      this.path = params['path'];
    });

    //First make sure they are not already logged in
    Auth.currentUserInfo().then(function(userInfo) {
      if (userInfo) {
        //redirect home if so
        window.location.href = "/dashboard";
      }
    });
            
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      rememberMe: [false]
    });
  }

  async signIn() {
    try {
      this.messageService.clear();
      this.signingIn = true;
      const username = this.loginForm.get('username').value.toLowerCase();
      const password = this.loginForm.get('password').value;

      if (!password) {
        setTimeout(function(){ document.getElementById("password").focus(); }, 300);
        this.signingIn = false;
      }
      else {
        // if (this.rememberMe == true) {
        //   console.log('setting to local storage');
        //   Auth.configure({ storage: localStorage });
        // }
        // else {
        //   console.log('setting to session storage');
        //   Auth.configure({ storage: sessionStorage });
        // }

        this.user = await Auth.signIn(username, password);
        this.runUserChallenges();
      }
    } 
    catch (error) {
      this.signingIn = false;
      if (error.message == "User is not confirmed.") {
        //If the user is not confirmed lets send it again and show the code dialog
        this.resendConfirmationCode();
        this.showCodeDialog = true;
        setTimeout(function(){ document.getElementById("CodeInput").focus(); }, 300);
      }
      else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message });
        console.log('error signing in', error);
        window.scrollTo(0,0);
      }
    }
  }

  async runUserChallenges() {
    //This right here is what would make the time based code required
    // if (!this.user.challengeName || this.user.challengeName === '') {
    //     //this.state = LoginState.setupTotp;
    //     await this.setupTotp();
    // }

    if (this.user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        this.showResetPasswordDialog = true;
        this.newPasswordRequired = true;
    }
    else if (this.user.challengeName === 'SOFTWARE_TOKEN_MFA') {
        this.showTotpDialog = true;
        setTimeout(function(){ document.getElementById("TotpCodeInput").focus(); }, 600);
    }
    else {
      if (this.returnUrl) {
        window.location.href = this.returnUrl;
      }
      else {
        window.location.href = "/dashboard";
      }
    }
  }

  async confirmResetPassword() {
    this.messageService.clear();
    this.resettingPassword = true;

    const username = this.loginForm.get('username').value.toLowerCase();

    if (this.newPassword != this.newPasswordAgain) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Passwords do not match.' });
      this.resettingPassword = false;
    }
    else {
      if (this.newPasswordRequired) {
        Auth.completeNewPassword(
          this.user, // the Cognito User Object
          this.newPassword, // the new password
        )
        .then(async data => {
          console.log(data);
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Password successfully changed! Please log in now.' });
          this.showResetPasswordDialog = false;
          this.resettingPassword = false;
          this.code = null;
          this.newPasswordAgain = null;
          this.newPassword = null;
          this.signingIn = false;
          this.loginForm.patchValue({['password']: ''});
          this.newPasswordRequired = false;
          await Auth.signOut();
          this.showSignIn(true);
        })
        .catch(err => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
          console.log(err);
          window.scrollTo(0,0);
          this.resettingPassword = false;
        });
      }
      else {
        // Collect confirmation code and new password, then
        Auth.forgotPasswordSubmit(username, this.code, this.newPassword)
        .then(data => {
          console.log(data);
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Password successfully changed! Please log in now.' });
          this.showResetPasswordDialog = false;
          this.resettingPassword = false;
          this.code = null;
          this.newPasswordAgain = null;
          this.newPassword = null;
          this.showSignIn(true);
        })
        .catch(err => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
          console.log(err);
          window.scrollTo(0,0);
          this.resettingPassword = false;
        });
      }    
    } 
  }

  showForgotPassword() {
    try {
      this.needsPassword = true;
      (<HTMLInputElement> document.getElementById('password')).style.display = "none";
    }
    catch (ex) {

    }
  }

  forgotPassword() {
    this.messageService.clear();
    this.resettingPassword = true;
    this.code = null;
    const username = this.loginForm.get('username').value.toLowerCase();

    // Send confirmation code to user's email
    Auth.forgotPassword(username)
    .then(data => {
      this.showResetPasswordDialog = true;
      setTimeout(function(){ document.getElementById("CodeInput").focus(); }, 300);
      console.log(data)
      this.resettingPassword = false;
    })
    .catch(err => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
      console.log(err);
      window.scrollTo(0,0);
      this.resettingPassword = false;
    });
  }

  showSignIn(dontClearMessages = false) {
    try {
      if (dontClearMessages == false) {
        this.messageService.clear();
      }
      this.logIn = true;
      this.needsPassword = false;
      (<HTMLInputElement> document.getElementById('password')).style.display = "block";
    }
    catch (ex) {

    }
  }

  hideResetPasswordDialog() {
    this.showResetPasswordDialog = false;
    this.code = null;
    this.newPassword = null;
    this.newPasswordAgain = null;
  }

  hideTotpCodeDialog() {
    this.totpCode = null;
    this.showTotpDialog = false;
    this.loginForm.patchValue({['password']: ''});
    this.loginForm.patchValue({['username']: ''});
    this.signingIn = false;
  }

  async confirmTotp() {
    try {
      this.confirmingTotp = true;
      this.messageService.clear();
      await Auth.confirmSignIn(this.user, this.totpCode, 'SOFTWARE_TOKEN_MFA');
      window.location.href = "/dashboard";
    } catch (error) {
        console.log('confirmTotp() err', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message });
        window.scrollTo(0,0);
    }

    this.confirmingTotp = false;
}

  async resendConfirmationCode() {
    try {
        await Auth.resendSignUp(this.loginForm.get('username').value.toLowerCase());
        console.log('code resent successfully');
    } 
    catch (err) {
        console.log('error resending code: ', err);
    }
  }
}
